import SetUserStatusRequestModelBase from '../_generated/modelBases/set-user-status-request-model-base';

export default class SetUserStatusRequestModel extends SetUserStatusRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
